module.exports = __webpack_public_path__ + "b3382dbe8326fac42666404c65cb1c0f.png";